(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wt-cart-cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
  function formatMoney(cents) {
    return '�' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function cheapestVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    return product.variants.reduce(function (a, b) {
      return (a.price < b.price) ? a : b;
    });
  }

  function buildSuggestion(product, tpl) {
    const node = tpl.content.cloneNode(true).querySelector('.wt-cart-cs__suggestion');
    const img = node.querySelector('.wt-cart-cs__img');
    const link = node.querySelector('.wt-cart-cs__img-link');
    const typeEl = node.querySelector('.wt-cart-cs__type');
    const priceEl = node.querySelector('.wt-cart-cs__price');
    const btn = node.querySelector('.wt-cart-cs__btn');

    const imgSrc = product.featured_image
      ? product.featured_image + '&width=128&height=128&crop=center'
      : '';
    img.src = imgSrc;
    img.alt = product.title || '';
    link.href = product.url;
    typeEl.textContent = (product.product_type || '') + ' - same design';
    const variant = cheapestVariant(product);
    priceEl.textContent = variant ? formatMoney(variant.price) : '';
    btn.dataset.variantId = variant ? variant.id : '';
    btn.setAttribute('aria-label', 'Add ' + (product.product_type || '') + ' to cart');

    btn.addEventListener('click', async function () {
      if (!variant || !variant.id) { window.location.href = product.url; return; }
      btn.setAttribute('aria-busy', 'true');
      try {
        const fd = new FormData();
        fd.append('id', variant.id);
        fd.append('quantity', '1');
        const resp = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!resp.ok) throw new Error('err');
        btn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {
        window.location.href = product.url;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
    return node;
  }

  function buildStatic(content) {
    const div = document.createElement('div');
    div.className = 'wt-cart-cs__static';
    div.innerHTML = '<span class="wt-cart-cs__static-text">' + content + '</span>';
    return div;
  }

  async function init() {
    const root = document.getElementById('wt-cart-cs');
    const content = document.getElementById('wt-cart-cs-content');
    const tpl = document.getElementById('wt-cart-cs-tpl');
    if (!root || !content) return;

    const cartIds = (root.dataset.cartProductIds || '').split(',').filter(Boolean);
    const firstProductId = root.dataset.firstProductId;
    if (!firstProductId) {
      content.innerHTML = '';
      root.classList.add('wt-cart-cs--empty');
      return;
    }

    try {
      const resp = await fetch('/recommendations/products.json?product_id=' + firstProductId + '&intent=complementary&limit=6');
      if (!resp.ok) throw new Error('err');
      const data = await resp.json();
      const products = (data.products || []).filter(function (p) {
        return !cartIds.includes(String(p.id));
      });

      content.innerHTML = '';

      if (!products.length) {
        content.appendChild(buildStatic('Add a matching mug from <a href="/collections/all?filter.p.product_type=Mug">�14.99</a> - same artwork, different format.'));
        return;
      }

      const pick = products[0];
      content.appendChild(buildSuggestion(pick, tpl));
    } catch (err) {
      content.innerHTML = '';
      content.appendChild(buildStatic('Add a matching mug from <a href="/collections/all?filter.p.product_type=Mug">�14.99</a> - same artwork, different format.'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
  const SORT_ORDER = ['mug','art print','poster','framed','canvas','tote','t-shirt','hoodie'];

  function typeRank(type) {
    const t = (type || '').toLowerCase();
    for (let i = 0; i < SORT_ORDER.length; i++) {
      if (t.includes(SORT_ORDER[i])) return i;
    }
    return 99;
  }

  function formatMoney(cents) {
    return '�' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function buildCard(product, tpl) {
    const card = tpl.content.cloneNode(true).querySelector('.wt-cross-sell__card');
    const img = card.querySelector('.wt-cross-sell__card-img');
    const link = card.querySelector('.wt-cross-sell__card-link');
    const typeEl = card.querySelector('.wt-cross-sell__card-type');
    const priceEl = card.querySelector('.wt-cross-sell__card-price');
    const btn = card.querySelector('.wt-cross-sell__card-btn');

    const imgSrc = product.featured_image
      ? product.featured_image + '&width=280&height=280&crop=center'
      : '';
    img.src = imgSrc;
    img.alt = product.title || '';
    link.href = product.url;
    typeEl.textContent = product.product_type || product.type || '';
    priceEl.textContent = formatMoney(product.price_min || product.price || 0);

    const variant = (product.variants && product.variants[0]) || {};
    btn.dataset.variantId = variant.id || '';
    btn.setAttribute('aria-label', 'Add ' + (product.product_type || '') + ' to cart');

    btn.addEventListener('click', async function () {
      if (!variant.id) { window.location.href = product.url; return; }
      btn.setAttribute('aria-busy', 'true');
      try {
        const fd = new FormData();
        fd.append('id', variant.id);
        fd.append('quantity', '1');
        const resp = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!resp.ok) throw new Error('cart error');
        btn.textContent = 'Added!';
        btn.classList.add('wt-cross-sell__card-btn--added');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {
        btn.textContent = 'View';
        window.location.href = product.url;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });

    return card;
  }

  async function initCrossSell(root) {
    const productId = root.dataset.productId;
    const container = root.querySelector('.wt-cross-sell__cards');
    const tpl = document.getElementById('wt-cross-sell-card-tpl');
    if (!productId || !container || !tpl) return;

    const currentType = (root.dataset.productType || '').toLowerCase();

    async function fetchAndRender(intent) {
      const url = '/recommendations/products.json?product_id=' + productId + '&intent=' + intent + '&limit=4';
      const resp = await fetch(url);
      if (!resp.ok) throw new Error('recs error');
      const data = await resp.json();
      return data.products || [];
    }

    try {
      let products = await fetchAndRender('complementary');

      if (!products.length) {
        products = await fetchAndRender('related');
      }

      products = products
        .filter(function (p) { return (p.product_type || '').toLowerCase() !== currentType; })
        .sort(function (a, b) { return typeRank(a.product_type) - typeRank(b.product_type); })
        .slice(0, 4);

      container.innerHTML = '';
      if (!products.length) {
        root.classList.add('wt-cross-sell--empty');
        return;
      }
      products.forEach(function (p) {
        container.appendChild(buildCard(p, tpl));
      });
    } catch (err) {
      root.classList.add('wt-cross-sell--empty');
    }
  }

  function init() {
    document.querySelectorAll('.wt-cross-sell').forEach(function (root) {
      initCrossSell(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
